import { useEffect, useState } from 'react';
import { ReactLenis, useLenis } from 'lenis/react';
import { ScrollProvider } from '../hooks/useScrollContext';

function LenisBridge({ children }) {
  const lenis = useLenis();
  return <ScrollProvider lenis={lenis}>{children}</ScrollProvider>;
}

export default function SmoothScroll({ children }) {
  const [reducedMotion, setReducedMotion] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    const update = () => setReducedMotion(mq.matches);
    update();
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, []);

  if (reducedMotion) {
    return <ScrollProvider lenis={null}>{children}</ScrollProvider>;
  }

  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <LenisBridge>{children}</LenisBridge>
    </ReactLenis>
  );
}
